import { Injectable } from "@angular/core";
import { BaseService } from "./base.service";
import { AppConstants } from "../app_setting/app-constants";
import {
  ResetPasswordRequest,
  ChangePasswordRequest,
  ActivationRequest,
  SetPinLimitRequest,
  ChangePinRequest,
  ChangeLimitRequest,
} from "../models/account";

@Injectable({
  providedIn: "root",
})
export class AuthenticationService extends BaseService {
  login(
    param: any,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.logout();

    this.post("account/LoginWebV3", param).subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          localStorage.setItem(AppConstants.TokenId, resp.data.bearer_token);
          localStorage.setItem(
            AppConstants.B2BStatus,
            resp.data.isCustomerEzB2B
          );
          localStorage.setItem(AppConstants.GTStatus, resp.data.isGeneralTrade);
          localStorage.setItem(AppConstants.TOPStatus, resp.data.isPBD2);
          localStorage.setItem(AppConstants.IsLogin, resp.data.isLogin);

          this.getAccountStatus(
            (respStatus) => {
              if (respStatus.alert.code == 200) {
                localStorage.setItem(
                  AppConstants.AccountStatusId,
                  JSON.stringify(respStatus.data)
                );
                this.getUserProfile(
                  (respProfile) => {
                    if (respProfile.alert.code == 200) {
                      localStorage.setItem(
                        AppConstants.ProfileStorageId,
                        JSON.stringify(respProfile.data)
                      );
                      onSuccess(respProfile);
                    } else {
                      // 417
                      if (respProfile.alert.code == 417) {
                        onError(respProfile.alert);
                      } else {
                        onError(respProfile.alert.message);
                      }
                    }
                  },
                  (err) => {
                    onError(err);
                  }
                );
              } else {
                onError(respStatus.alert);
              }
            },
            (err) => {
              onError(err);
            }
          );
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  getAccountStatus(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get(`/account/status`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        // onError(err);
        // 417
        if (err.alert.code == 417) {
          onError(err.alert);
        } else {
          onError(err.alert.message);
        }
      }
    );
  }

  getLimit(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get(`/v2/user/get-limit`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  getRemarksActivation(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get(`/account/remarks-activation`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  forgotPassword(
    email: string,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    let param = '"' + email + '"';
    this.post("/account/req_fpswd", param).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  resendEmail(
    idRequest: string,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.post(`/account/req_fpswd/resend/${idRequest}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  getAccountData(
    uniqueId: string,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get(`/account/fpswd?id=${uniqueId}`).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  resetPassword(
    param: ResetPasswordRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.put(`/account/fpswd`, param).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  changePassword(
    param: ChangePasswordRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.put(`/account/password`, param).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  submitActivation(
    param: ActivationRequest,
    onSuccess: (data) => void,
    onError: (data) => void = null
  ): any {
    const formData = new FormData();
    formData.append("Phone", param.Phone);
    formData.append("Email", param.Email);
    formData.append("IdentityCardFile", param.IdentityCardFile);
    this.putMultipartFormData("/account/activation", formData).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  setPinLimit(
    param: SetPinLimitRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.post(`/account/pin_and_limit`, param).subscribe(
      (resp) => {
        if (resp.alert.code == 200) {
          this.updateAccountSession(
            (resp) => {
              onSuccess(resp);
            },
            (err) => {
              onError(err);
            }
          );
        } else {
          onError(resp.alert.message);
        }
      },
      (err) => {
        onError(err);
      }
    );
  }

  // changeLimit(param: ChangeLimitRequest, onSuccess: (data: any) => void, onError: (data: any) => void = null): any {
  //   this.put(`/account/limit`, param)
  //   .subscribe(
  //     resp => {
  //       if(resp.alert.code == 200){
  //       localStorage.removeItem(AppConstants.ProfileStorageId);
  //       this.getUserProfile((respProfile) => {
  //         if(respProfile.alert.code == 200){
  //           localStorage.setItem(AppConstants.ProfileStorageId, JSON.stringify(respProfile.data));
  //           onSuccess(respProfile);
  //         }else{
  //           onError(respProfile.alert.message);
  //         }
  //       },
  //       err => {
  //         onError(err);
  //       });
  //       }else{
  //         onError(resp.alert.message);
  //       }
  //     },
  //     err => {
  //        onError(err);
  //     });
  //   }

  changeLimit(
    param: ChangeLimitRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.put(`/v2/user/limit`, param).subscribe(
      (resp) => {
        if (resp.alert.code == 200) {
          localStorage.removeItem(AppConstants.ProfileStorageId);
          this.getUserProfile(
            (respProfile) => {
              if (respProfile.alert.code == 200) {
                localStorage.setItem(
                  AppConstants.ProfileStorageId,
                  JSON.stringify(respProfile.data)
                );
                onSuccess(respProfile);
              } else {
                onError(respProfile.alert.message);
              }
            },
            (err) => {
              onError(err);
            }
          );
        } else {
          onError(resp.alert.message);
        }
      },
      (err) => {
        onError(err);
      }
    );
  }

  changePin(
    param: ChangePinRequest,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.put(`/account/pin`, param).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  validationPin(
    param: string,
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.post(`/account/validation/pin`, param).subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  isLogged(): boolean {
    const token = localStorage.getItem(AppConstants.TokenId);
    return token !== null && token !== "";
  }

  getAccountStatusData(): any {
    return JSON.parse(localStorage.getItem(AppConstants.AccountStatusId));
  }

  getProfileData(): any {
    return JSON.parse(localStorage.getItem(AppConstants.ProfileStorageId));
  }

  getB2BStatus(): any {
    return localStorage.getItem(AppConstants.B2BStatus);
  }

  logout(): void {
    localStorage.setItem(AppConstants.TokenId, "");
    localStorage.clear();
  }

  updateAccountSession(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    localStorage.removeItem(AppConstants.ProfileStorageId);
    localStorage.removeItem(AppConstants.AccountStatusId);

    this.getAccountStatus(
      (respStatus) => {
        if (respStatus.alert.code == 200) {
          localStorage.setItem(
            AppConstants.AccountStatusId,
            JSON.stringify(respStatus.data)
          );
          this.getUserProfile(
            (respProfile) => {
              if (respProfile.alert.code == 200) {
                localStorage.setItem(
                  AppConstants.ProfileStorageId,
                  JSON.stringify(respProfile.data)
                );
                onSuccess(respProfile);
              } else {
                onError(respProfile.alert);
              }
            },
            (err) => {
              onError(err);
            }
          );
        } else {
          onError(respStatus.alert);
        }
      },
      (err) => {
        onError(err);
      }
    );
  }

  getUserProfile(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get("/profile").subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  getAddresss(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get("/address").subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  getObjUserProfile(): any {
    const jsonProfile = localStorage.getItem(AppConstants.ProfileStorageId);

    if (jsonProfile != null && jsonProfile != "" && jsonProfile != undefined) {
      return JSON.parse(jsonProfile);
    } else {
      return null;
    }
  }

  getUserConsentWording(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get("/v3/UserConsent").subscribe(
      (resp) => {
        if (resp.alert.code === 200) {
          onSuccess(resp.data);
        } else {
          onError(resp.alert);
        }
      },
      (err) => {
        if (onError) {
          console.log(err);
        }
      }
    );
  }

  getGTContent(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get('/general_trade/GeneralTradeTemplate').subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }

  getGTStatus(
    onSuccess: (data: any) => void,
    onError: (data: any) => void = null
  ): any {
    this.get('/general_trade/GetCheckStatusGT').subscribe(
      (resp) => {
        onSuccess(resp);
      },
      (err) => {
        onError(err);
      }
    );
  }
}
